import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";

const BlogPostCard = ({ title, thumbnail, slug, excerpt, date, category }) => (
  <li className="flex py-4 px-0 sm:pr-4">
    <section className="m-0 w-full sm:w-80 sm:mr-6 lg:w-88">
      <Link
        to={`/blog/${slug}`}
        className="rounded-md overflow-hidden focus:outline-none focus:shadow-outline block"
      >
        <Img
          alt={title}
          fluid={thumbnail.childImageSharp.fluid}
          className="h-56 w-full sm:h-48 md:h-40 lg:h-48"
        />
      </Link>
      <div className="block sm:hidden">
        <Link
          to={`/category/${category.toLowerCase()}`}
          className="text-indigo-800 bg-indigo-100 px-3 py-1 mb-1 inline-block rounded-full text-xs mt-2 focus:outline-none focus:shadow-outline"
        >
          {category}
        </Link>
        <h2 className="font-bold text-lg my-2">
          <Link
            to={`/blog/${slug}`}
            className="focus:outline-none focus:text-indigo-700"
          >
            {title}
          </Link>
        </h2>
        <div className="text-sm mb-2 text-primary">
          <i className="fa fa-calendar-alt" />
          {`  ${date}`}
        </div>
        <p className="text-sm text-gray-700 leading-tight">{excerpt}</p>
      </div>
      <Link
        to={`/blog/${slug}`}
        className="uppercase rounded-md inline-block p-2 text-center bg-primary text-white text-xs mt-2 w-full sm:hidden hover:bg-primary-dark focus:outline-none focus:shadow-outline"
      >
        Read More
      </Link>
    </section>
    <section className="hidden w-0 sm:block sm:w-full">
      <Link
        to={`/category/${category.toLowerCase()}`}
        className="text-indigo-800 bg-indigo-100 px-3 py-1 mb-1 inline-block rounded-full text-xs focus:outline-none focus:shadow-outline"
      >
        {category}
      </Link>
      <h2 className="font-bold text-lg mb-2">
        <Link
          to={`/blog/${slug}`}
          className="focus:outline-none focus:text-indigo-700"
        >
          {title}
        </Link>
      </h2>
      <div className="text-sm mb-2 text-primary">
        <i className="fa fa-calendar-alt" />
        {`  ${date}`}
      </div>
      <p className="text-sm text-gray-700 leading-tight">{excerpt}</p>
      <div className="flex justify-end">
        <Link
          to={`/blog/${slug}`}
          className="uppercase rounded-md hidden py-2 px-3 text-center bg-primary text-white text-xs mt-2 sm:inline-block hover:bg-primary-dark  focus:outline-none focus:shadow-outline"
        >
          Read More
        </Link>
      </div>
    </section>
  </li>
);

export default BlogPostCard;
